import { useState } from "react";
import { Link } from "react-router-dom";

export function SearchTools() {
  const [query, setQuery] = useState("");

  const tools = [
    { name: "API Tester", path: "/api-tester" },
    { name: "Base64 Tool", path: "/tools/base64" },
    { name: "JSON Formatter", path: "/tools/json" },
  ];

  const filteredTools = tools.filter(tool =>
    tool.name.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div>
      <h2>Search Tools</h2>
      <input
        type="text"
        placeholder="Search for tools..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        style={{
          width: '300px',
          padding: '8px',
          marginBottom: '16px',
          fontSize: '16px'
        }}
      />
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {filteredTools.map((tool) => (
          <li key={tool.path} style={{ marginBottom: '8px' }}>
            <Link to={tool.path} style={{ textDecoration: 'none', color: '#61dafb' }}>
              {tool.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}